<div class="plans-container" *ngIf="content">
  <div class="plans" *ngIf="!hasSubscription">
    <div class="plan" *ngFor="let plan of plans">
      <ng-container *ngIf="testResult$ | async as testResult">
        <div class="plan__price">
          <div class="plan__name">{{ plan.name[currentLocale$ | async] }}</div>
          <div class="plan__price-per-day">{{ pricePerMonth(plan, testResult.co2e) | round: 2 }}€</div>

          <span class="plan__price-per-day-label">{{ content.fields.perMonth }}</span>
          <span class="plan__price-per-month">
            ({{ pricePerDay(plan, testResult.co2e) | round: 2 }}€ / {{ content.fields.perDay }})
          </span>
        </div>
        <div class="plan__description" *ngIf="plan.name['en-US'] === 'Compensate'">
          {{ content.fields.compensatePlanDescription }}
        </div>
        <div class="plan__description" *ngIf="plan.name['en-US'] === 'Compensate + Clean up'">
          {{ content.fields.compensateCleanUpPlanDescription }}
        </div>
        <button class="plan__button" (click)="selectPlan(plan, testResult)">{{ content.fields.ctaText }}</button>
      </ng-container>
    </div>
    <div class="plan plan--mailinglist" *ngIf="!(isLoggedIn$ | async)">
      <div class="plan__name">{{ content.fields.joinBlockTitle }}</div>
      <div class="plan__description">{{ content.fields.joinBlockIngress }}</div>
      <button class="plan__button" (click)="registerOnly()">{{ content.fields.joinBlockCtaText }}</button>
    </div>
  </div>
  <div *ngIf="hasSubscription">
    <div class="banner-text-container">
      <h2 class="banner-text-container__heading">
        {{ content.fields.alreadySubscriberText }}
        <a class="banner-text-container__link" [routerLink]="content.fields.alreadySubscriberLinkUrl">
          {{ content.fields.alreadySubscriberLinkText }}
        </a>
      </h2>
    </div>
  </div>
</div>
